import { Spinner } from "@cohesive/ui-components";

/**
 * Thin wrapper around a spinner + message that every content renderer
 * mounts while its underlying `<img>` / `<iframe>` / text fetch is still
 * in flight. Keeps the loading UX identical across content kinds so
 * switching between e.g. a PDF and a DOCX in the same session doesn't
 * feel like two different products.
 */
export function LoadingOverlay() {
  return (
    <div className="absolute inset-0 flex items-center justify-center">
      <div className="flex flex-col items-center gap-4">
        <Spinner size="lg" />
      </div>
    </div>
  );
}
